module.exports = __webpack_public_path__ + "img/logotable.13da2323.png";